import { withStyles } from "@material-ui/styles";
import cx from "classnames";
import CustomButton from "../CustomButton";

const styles = theme => ({
  buttonClass: {
    ...theme.typography.defaultFont,
    ...theme.flexClass,
    "--bg-color": props => props.bgColor ?? "#2A89F6",
    "--text-color": props =>
      props.textColor
        ? props.textColor
        : props.variant === "outlined"
        ? "var(--bg-color)"
        : "#FFFFFF",
    padding: "8px 12px",
    background: props =>
      props.variant === "outlined"
        ? props.transparentBg
          ? "transparent"
          : "#FFFFFF"
        : "var(--bg-color)",
    color: "var(--text-color)",
    borderRadius: "100px",
    border: props =>
      props.variant === "outlined"
        ? props.border ?? "1.5px solid rgba(42, 137, 246, 0.6)"
        : "none",
    fontSize: "13px",
    ["@media (min-width:576px)"]: {
      fontSize: "0.938rem"
    },
    fontWeight: props => props.weight ?? "700",
    "& img": {
      margin: props => (props.alignIcon === "right" ? "0 0 0 6px" : "0 6px 0 0")
    },
    marginRight: "6px",
    "&:disabled": {
      pointerEvents: "none",
      color: props => props.disabledColor || "#7C8BA2",
      background: props =>
        props.variant === "outlined" ? "#FFFFFF" : "rgba(124, 139, 162, 0.6)",
      border: props =>
        props.variant === "outlined"
          ? "1.5px solid rgba(124, 139, 162, 0.6)"
          : "none"
    },
    "&:hover": {
      color: props =>
        props.hasHoverAnimation ? "var(--bg-color) !important" : "",
      background: props =>
        props.hasHoverAnimation ? "var(--text-color) !important" : ""
    }
  },
  buttonClassV2: {
    ...theme.typography.defaultFont,
    ...theme.flexClass,
    "--bg-color": props => props.bgColor ?? "#2A89F6",
    "--text-color": props =>
      props.textColor
        ? props.textColor
        : props.variant === "outlined"
        ? "var(--bg-color)"
        : "#FFFFFF",
    padding: "8px 12px",
    borderRadius: "100px",
    border: props =>
      props.variant === "outlined"
        ? props.border ?? "1.5px solid rgba(42, 137, 246, 0.6)"
        : "none",
    fontSize: "13px",
    ["@media (min-width:576px)"]: {
      fontSize: "0.938rem"
    },
    fontWeight: props => props.weight ?? "700",
    "& img": {
      margin: props => (props.alignIcon === "right" ? "0 0 0 6px" : "0 6px 0 0")
    },
    marginRight: "6px",
    "&:disabled": {
      pointerEvents: "none",
      color: props => props.disabledColor || "#7C8BA2",
      background: props =>
        props.variant === "outlined" ? "#FFFFFF" : "rgba(124, 139, 162, 0.6)",
      border: props =>
        props.variant === "outlined"
          ? "1.5px solid rgba(124, 139, 162, 0.6)"
          : "none"
    },
    "&:hover": {
      color: props =>
        props.hasHoverAnimation ? "var(--bg-color) !important" : "",
      background: props =>
        props.hasHoverAnimation ? "var(--text-color) !important" : ""
    }
  }
});
const CustomButtonWrapper = props => {
  const {
    classes,
    customClass,
    iconUrl,
    content = "",
    alt = "icon",
    alignIcon = "left",
    height = 16,
    width = 16,
    v2,
    ...otherProps
  } = props;
  return (
    <CustomButton
      className={cx(
        customClass,
        v2 ? classes.buttonClassV2 : classes.buttonClass
      )}
      {...otherProps}
    >
      {iconUrl && alignIcon === "left" ? (
        <img src={iconUrl} alt={alt} height={height} width={height} />
      ) : null}
      {content}
      {iconUrl && alignIcon === "right" ? (
        <img src={iconUrl} alt={alt} height={height} width={height} />
      ) : null}
    </CustomButton>
  );
};

export default withStyles(styles)(CustomButtonWrapper);
